import SchoolIcon from "@mui/icons-material/School";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import WorkIcon from "@mui/icons-material/Work";
import GroupsIcon from "@mui/icons-material/Groups";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DesktopMacIcon from "@mui/icons-material/DesktopMac";
import CodeIcon from "@mui/icons-material/Code";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import LanguageIcon from "@mui/icons-material/Language";
import EngineeringIcon from "@mui/icons-material/Engineering";
import StoreIcon from "@mui/icons-material/Store";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import BrushIcon from "@mui/icons-material/Brush";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import BusinessIcon from "@mui/icons-material/Business";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import StorageIcon from "@mui/icons-material/Storage";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import ShareIcon from "@mui/icons-material/Share";
import CreateIcon from "@mui/icons-material/Create";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import React from "react";

// ────────────────────────────────────────────────────
//  Full Stack Development Training Data
// ────────────────────────────────────────────────────
export const fullStackTrainingData = {
  hero: {
    title: "Full Stack Web Development Training in Bengaluru",
    subtitle: "Master real-world skills with live projects, expert mentors & guaranteed placement support.",
    badgeText: "🚀 New Batch Starting Monday — Limited Seats Available!",
    buttonText: "Book Your Seat",
    urgencyText: "Limited Slots: Next Batch Starts this Monday!",
    secondaryButtonText: "Get Brochure",
    formTitle: "Start Your Journey",
    formSubtitle: "Fill the form below and speak with our training advisor.",
    namePlaceholder: "Your Full Name",
    phonePlaceholder: "Phone Number",
    coursePlaceholder: "Select Desired Course",
    submitButtonText: "Apply for Early Seat",
    supportText: "Support: ",
    supportPhone: "+91 99648 48414",
    features: [
      { icon: SchoolIcon, text: "Expert Industry Instructors" },
      { icon: GroupsIcon, text: "Small Batch for Personalized Attention" },
      { icon: WorkIcon, text: "100% Placement Assistance" },
      { icon: LaptopMacIcon, text: "Live Projects & Hands-On Learning" },
      { icon: EmojiEventsIcon, text: "Industry-Recognized Certificate" },
      { icon: AccessTimeIcon, text: "Flexible Batch Timings" },
    ],
    courses: ["Full Stack Development", "UI/UX Design", "Digital Marketing", "Mobile App Development"],
  },

  about: {
    badge: "Specialized Full Stack Training",
    title: "Website Design & Development Program — Built for Results",
    description1: "Vihaan Innovations' Full Stack program is designed for ambitious learners — fresh graduates, career-switchers, and working professionals — who want to build real, deployable web applications and land a high-paying tech job within months.",
    description2: "Unlike generic online courses, our program combines structured classroom instruction with live client projects, weekly evaluations, and a dedicated placement cell. You don't just learn — you build, deploy, and present your work to real recruiters.",
    highlights: [
      "Expertly Designed, Industry-Aligned Curriculum",
      "Practical Learning with Real-World Scenarios",
      "Career Growth Roadmap with Mentorship Sessions",
      "Cutting-Edge Technologies & Tools Covered",
      "Personalized Guidance & 1-on-1 Doubt Sessions",
    ],
    stats: [
      { label: "Program Duration", value: "6 Months" },
      { label: "Batch Size", value: "Max 20 Students" },
      { label: "Mode of Training", value: "Online + Offline" },
      { label: "Projects", value: "5+ Live Projects" },
      { label: "Certification", value: "Industry Certificate" },
      { label: "EMI Available", value: "0% Interest Plans" },
    ],
  },

  courses: {
    badge: "Available Modules",
    title: "Master the Most In-Demand Skills",
    subtitle: "Choose the path that fits your career goals.",
    courses: [
      {
        id: 0, label: "Front-End Mastery",
        duration: "2 Months", mode: "Online / Offline", level: "Beginner to Advanced",
        skills: ["HTML5 & CSS3 Essentials", "JavaScript (ES6+) Core", "React.js Framework", "Bootstrap 5 & Tailwind", "Responsive Web Design", "Git & Version Control"],
      },
      {
        id: 1, label: "Back-End & APIs",
        duration: "2 Months", mode: "Online / Offline", level: "Intermediate",
        skills: ["Node.js & Express.js", "RESTful API Design", "JWT Authentication", "MongoDB & NoSQL", "SQL & Database Design", "Middleware & Security"],
      },
      {
        id: 2, label: "Full Stack Deployment",
        duration: "2 Months", mode: "Online / Offline", level: "Advanced",
        skills: ["MERN Stack Integration", "Cloud Deployment (AWS/Vercel)", "System Architecture", "Software Testing Basics", "Performance Optimization", "Live Capstone Project"],
      },
    ],
  },

  curriculum: {
    badge: "Course Roadmap",
    title: "Your Roadmap to Success.",
    subtitle: "A structured, progressive learning path designed to make you an industry expert.",
    roadmap: [
      { month: "Month 1", title: "Foundations", topics: ["HTML5 & CSS3 Mastery", "JavaScript Core Concepts", "Git Version Control", "Responsive Design Principles"] },
      { month: "Month 2", title: "Front-End Development", topics: ["React.js Fundamentals", "State & Props Management", "Component Architecture", "Bootstrap Integration"] },
      { month: "Month 3", title: "Back-End Basics", topics: ["Node.js & Express Setup", "REST API Design", "JWT Authentication", "Middleware & Error Handling"] },
      { month: "Month 4", title: "Database & Storage", topics: ["MySQL Relational Design", "MongoDB NoSQL Queries", "PostgreSQL Advanced", "Data Modeling & ORM"] },
      { month: "Month 5", title: "Full Stack Integration", topics: ["MERN Stack Project", "File Uploads & Cloud", "WebSocket Real-time", "Deployment Basics"] },
      { month: "Month 6", title: "Career & Capstone", topics: ["Live Capstone Project", "Resume & Portfolio Building", "Mock Interviews", "Placement Drive"] },
    ],
  },

  features: {
    badge: "Why Choose Us",
    title: "What Makes Us Different.",
    subtitle: "Everything we do is designed to accelerate your career, not just check a course box.",
    features: [
      { icon: <SchoolIcon fontSize="large" />, title: "Expert Instructors", desc: "Learn from industry professionals with 10+ years of real-world experience in top companies." },
      { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build 5+ real-world projects that go directly into your professional portfolio." },
      { icon: <WorkIcon fontSize="large" />, title: "100% Placement Support", desc: "Dedicated placement cell with 200+ hiring partners across India." },
      { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Small batches of 20 students for personalized attention and better interaction." },
      { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Week-by-week curriculum designed with input from industry leaders and companies." },
      { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime LMS Access", desc: "Access all recorded sessions, notes and future updates forever at no extra cost." },
    ],
  },

  testimonials: {
    badge: "Alumni Success",
    title: "Join 1200+ Successful Alumni.",
    subtitle: "Hear what our alumni say about their experience at Vihaan Innovations.",
    testimonials: [
      { name: "Priya S.", role: "Full Stack Developer @ TCS", rating: 5, text: "Vihaan's training gave me confidence to switch careers. The hands-on projects and placement support were exceptional!" },
      { name: "Rahul M.", role: "UI Engineer @ Infosys", rating: 5, text: "Best investment I made. The instructors are very approachable, the curriculum is practical and up-to-date." },
      { name: "Sneha A.", role: "React Developer @ Startup", rating: 5, text: "I joined as a complete beginner and landed a job within 2 months of completing the course. Highly recommend!" },
      { name: "Kiran T.", role: "Backend Dev @ Wipro", rating: 4, text: "The Node.js and database modules were incredibly well-structured. I finally understand full-stack architecture end-to-end." },
    ],
  },

  cta: {
    title: "Ready to Become a Full Stack Developer?",
    subtitle: "Learn from the best. Build real projects. Get hired. Join 1200+ students who transformed their careers with Vihaan Innovations.",
    primaryButton: "Enroll Now →",
    secondaryButton: "Download Syllabus",
    footerText: "* New batch starting this Monday. Limited slots left.",
  },

  whoCanApply: {
    badge: "Eligibility",
    title: "Who Can Apply for the Course?",
    subtitle: "Our program is open to anyone with the drive to learn. No prior coding experience required — just ambition.",
    stats: [
      { num: 1200, label: "Alumni placed", suffix: "+" },
      { num: 200, label: "Hiring partners", suffix: "+" },
      { num: 500, label: "Projects built", suffix: "+" },
      { num: 100, label: "Placement assistance", suffix: "%" },
    ],
    audience: [
      { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Final year students and fresh graduates looking to build a career in IT", accent: "#1a472a", bg: "#e8f0eb" },
      { icon: <EngineeringIcon sx={{ fontSize: 28 }} />, label: "IT Professionals", text: "Experienced IT professionals seeking a meaningful career change", accent: "#b45309", bg: "#fef3c7" },
      { icon: <DesktopMacIcon sx={{ fontSize: 28 }} />, label: "Aspiring Developers", text: "Self-learners and aspiring web developers ready to go professional", accent: "#1d4ed8", bg: "#dbeafe" },
      { icon: <CodeIcon sx={{ fontSize: 28 }} />, label: "Freelancers & Consultants", text: "Passionate programmers, freelancers and independent consultants", accent: "#6d28d9", bg: "#ede9fe" },
      { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Business owners and bloggers who want to build and manage their own web presence", accent: "#be185d", bg: "#fce7f3" },
      { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Programming Professionals", text: "Professionals already in tech who want to expand their full-stack capabilities", accent: "#0e7490", bg: "#cffafe" },
    ],
  },

  tools: [
    { name: "VS Code", color: "#007ACC" },
    { name: "Git / GitHub", color: "#F05032" },
    { name: "Postman", color: "#FF6C37" },
    { name: "Chrome DevTools", color: "#4285F4" },
    { name: "React DevTools", color: "#61DAFB" },
    { name: "Vercel / Netlify", color: "#000000" },
  ],
};

// Helper: build a standard training data object quickly
const makeTrainingData = ({
  heroTitle, heroSubtitle, heroBadge, heroUrgency, heroFormTitle, heroFormSubtitle, heroFormBtn,
  aboutTitle, aboutBadge, about1, about2, aboutHighlights, aboutStats,
  duration, courseLabel,
  frontEnd, backEnd, database,
  months,
  ctaTitle, ctaSubtitle, ctaFooter,
  audience, tools,
  testimonialsList,
  whyChooseUsList,
  certification
}) => {
  // Standardize tools to object format if they are strings
  const formattedTools = (tools || []).map(t => {
    if (typeof t === "string") {
      return { name: t, color: "#00b4d8" }; // Default blue for string tools
    }
    return t;
  });

  return {
    hero: {
      title: heroTitle,
      subtitle: heroSubtitle,
      badgeText: heroBadge || "🚀 New Batch Starting Monday — Limited Seats Available!",
      buttonText: "Book Your Seat",
      urgencyText: heroUrgency || "⚡ Limited Slots: Next Batch Starts this Monday!",
      secondaryButtonText: "Get Brochure",
      formTitle: heroFormTitle || "Start Your Journey",
      formSubtitle: heroFormSubtitle || "Fill the form below and speak with our training advisor.",
      namePlaceholder: "Your Full Name",
      phonePlaceholder: "Phone Number",
      coursePlaceholder: "Select Desired Course",
      submitButtonText: heroFormBtn || "Apply for Early Seat",
      supportText: "Support: ",
      supportPhone: "+91 99648 48414",
      features: [
        { icon: SchoolIcon, text: "Expert Industry Instructors" },
        { icon: GroupsIcon, text: "Small Batch for Personalized Attention" },
        { icon: WorkIcon, text: "100% Placement Assistance" },
        { icon: LaptopMacIcon, text: "Live Projects & Hands-On Learning" },
        { icon: EmojiEventsIcon, text: "Expert Mentorship" },
        { icon: AccessTimeIcon, text: "Flexible Batch Timings" },
      ],
      courses: [courseLabel],
    },
    about: {
      badge: aboutBadge || `Specialized ${courseLabel} Training`,
      title: aboutTitle,
      description1: about1,
      description2: about2 || "Our program combines structured classroom instruction with live projects, weekly evaluations, and a dedicated placement cell.",
      highlights: aboutHighlights || [
        "Expertly Designed, Industry-Aligned Curriculum",
        "Practical Learning with Real-World Scenarios",
        "Career Growth Roadmap with Mentorship Sessions",
        "Cutting-Edge Technologies & Tools Covered",
        "Personalized Guidance & 1-on-1 Doubt Sessions",
      ],
      stats: aboutStats || [
        { label: "Program Duration", value: duration },
        { label: "Batch Size", value: "Max 20 Students" },
        { label: "Mode of Training", value: "Online + Offline" },
        { label: "Projects", value: "5+ Live Projects" },
        { label: "Expert Support", value: "24/7 Availability" },
        { label: "EMI Available", value: "0% Interest Plans" },
      ],
    },
    courses: {
      badge: "Skills You Will Master",
      title: `Master In-Demand Skills with Our ${courseLabel} Training`,
      subtitle: "Choose the right learning path to become an expert.",
      courses: [
        { id: 0, label: `${courseLabel} Fundamentals`, duration: duration, mode: "Online / Offline", level: "Beginner", skills: frontEnd },
        { id: 1, label: `Advanced ${courseLabel}`, duration: duration, mode: "Online / Offline", level: "Intermediate", skills: backEnd },
        { id: 2, label: `${courseLabel} Mastery & Projects`, duration: duration, mode: "Online / Offline", level: "Advanced", skills: database },
      ],
    },
    curriculum: {
      badge: "Course Roadmap",
      title: `Your Step-by-Step ${courseLabel} Journey`,
      subtitle: "A structured, progressive learning path designed to make you an industry expert.",
      roadmap: months,
    },
    features: {
      badge: "Why Choose Us",
      title: "What Makes Our Training Different",
      subtitle: "Everything we do is designed to accelerate your career, not just check a course box.",
      features: whyChooseUsList || [
        { icon: <SchoolIcon fontSize="large" />, title: "Expert Instructors", desc: "Learn from industry professionals with 10+ years of hands-on experience." },
        { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build 5+ real-world projects that go directly into your professional portfolio." },
        { icon: <WorkIcon fontSize="large" />, title: "100% Placement Support", desc: "Dedicated placement cell with 200+ hiring partners across India." },
        { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Small batches of 20 students for personalized attention." },
        { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
        { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime LMS Access", desc: "Access all recorded sessions, notes and future updates forever." },
      ],
    },
    testimonials: {
      badge: "Alumni Success",
      title: "Join 1200+ Successful Alumni.",
      subtitle: "Hear what our alumni say about their experience at Vihaan Innovations.",
      testimonials: testimonialsList || [
        { name: "Priya S.", role: `${courseLabel} Graduate @ TCS`, rating: 5, text: "Vihaan's training gave me confidence to switch careers. The projects were very practical!" },
        { name: "Rahul M.", role: `${courseLabel} @ Infosys`, rating: 5, text: "Best investment I made. The instructors are very approachable, the curriculum is practical." },
        { name: "Sneha A.", role: `${courseLabel} @ Startup`, rating: 5, text: "I joined as a complete beginner and landed a job within 2 months. Highly recommend!" },
      ],
    },
    cta: {
      title: ctaTitle || `Ready to Master ${courseLabel}?`,
      subtitle: ctaSubtitle || "Learn from the best. Build real projects. Get hired. Join 1200+ students who transformed their careers.",
      primaryButton: "Enroll Now →",
      secondaryButton: "Download Syllabus",
      footerText: ctaFooter || "* New batch starting soon. Limited slots left.",
      audience: audience || [],
    },
    certification: certification || {
      badge: "Industry Recognized",
      title: "Earn a Certificate That Opens Doors.",
      subtitle: "Upon successful completion of the course and projects, you receive an industry-recognized certification verified by Vihaan Innovations.",
    },
    tools: formattedTools,
  };
};

// ── Digital Marketing Training ──
export const seoTrainingData = makeTrainingData({
  heroTitle: "Online SEO Training in Bengaluru - Rank #1 on Google",
  heroSubtitle: "Our Digital marketing SEO training can take your marketing business to new heights. Learn keyword research, on-page SEO, technical SEO, and analytics with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your SEO Career Today",
  heroFormSubtitle: "Fill in your details and connect with our expert training advisors.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Online SEO Training Program - From Basics to Advanced",
  aboutBadge: "Specialized SEO Training",
  about1: "Our online SEO training helps you learn search engine optimization from scratch with a practical approach.",
  about2: "This digital marketing SEO course covers on-page, technical SEO, and link building with real-time projects.",
  aboutHighlights: [
    "Industry-aligned SEO curriculum",
    "Hands-on training with live projects",
    "Career guidance & mentorship",
    "Advanced SEO tools covered",
    "1-on-1 doubt sessions",
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "SEO",
  frontEnd: ["Keyword Research", "On-Page SEO", "Meta Tags & Schema", "Content Optimization", "URL Structure", "Internal Linking"],
  backEnd: ["Technical SEO", "Link Building Strategies", "Domain Authority", "Google Search Console", "Site Speed Optimization", "Core Web Vitals"],
  database: ["Google Analytics 4", "SEMrush", "Ahrefs", "Moz Tools", "Live Projects", "SEO Audits"],
  months: [
    { month: "Week 1-2", title: "SEO Fundamentals", topics: ["How Search Engines Work", "SEO Basics & Ranking Factors", "Keyword Research Introduction"] },
    { month: "Week 3-4", title: "Keyword Research & Strategy", topics: ["Advanced Keyword Research", "Search Intent & Keyword Mapping", "Competitor Analysis"] },
    { month: "Week 5-6", title: "On-Page SEO", topics: ["Meta Tags Optimization", "URL Structure", "Heading Tags", "On-Page Optimization Techniques"] },
    { month: "Week 7-8", title: "Content Strategy", topics: ["SEO Content Writing", "Blog Optimization", "Content Planning", "Internal Linking"] },
    { month: "Week 9-10", title: "Technical SEO", topics: ["Website Architecture", "Crawling & Indexing", "Core Web Vitals", "Mobile SEO & Schema"] },
    { month: "Week 11-12", title: "Off-Page SEO & Analytics", topics: ["Link Building & Guest Posting", "DA/PA Analysis", "Local SEO", "Google Analytics & Search Console", "SEO Audit & Final Project"] },
  ],
  ctaTitle: "Ready to Start Your Online SEO Training Journey?",
  ctaSubtitle: "Learn from experts, work on real projects, and build a successful career with our digital marketing SEO training.",
  audience: [
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer high-demand SEO services and build your own agency", accent: "#1a472a", bg: "#e8f0eb" },
    { icon: <BusinessIcon sx={{ fontSize: 28 }} />, label: "Small Business Owners", text: "Stop paying agencies and take control of your own rankings", accent: "#b45309", bg: "#fef3c7" },
    { icon: <GroupsIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Master SEO to command higher salaries and better roles", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Graduates", text: "Start your career with an industry-recognized certification", accent: "#6d28d9", bg: "#ede9fe" },
  ],
  tools: [
    { name: "Google Search Console", color: "#4285F4" },
    { name: "Google Analytics 4", color: "#F4B400" },
    { name: "Ahrefs", color: "#007ACC" },
    { name: "SEMrush", color: "#FF642D" },
    { name: "Screaming Frog", color: "#4DB33D" },
    { name: "Moz Pro", color: "#00B4D8" },
    { name: "PageSpeed Insights", color: "#DB4437" },
  ],
  testimonialsList: [
    { name: "Rahul Deshpande", role: "SEO Specialist @ Zoomcar", rating: 5, text: "The technical SEO modules were eye-opening. I applied the concepts to a live project and saw 40% growth in traffic." },
    { name: "Sanya Mehta", role: "Content Head @ Zomato", rating: 5, text: "Keyword research was something I thought I knew, but this course taught me the real depth." },
  ],
});

export const semTrainingData = makeTrainingData({
  heroTitle: "SEM Training in Bengaluru - Master Google Ads & Paid Marketing",
  heroSubtitle: "Learn paid advertising with our expert-led SEM training. Master Google Ads, campaign optimization, keyword bidding, and ROI-driven strategies with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your SEM Career Today",
  heroFormSubtitle: "Fill in your details and connect with our paid marketing experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "SEM Training Program - From Basics to Advanced",
  aboutBadge: "Specialized SEM Training",
  about1: "Our SEM training helps you master paid advertising and Google Ads from scratch with a practical approach.",
  about2: "This sem marketing course covers campaign setup, keyword targeting, ad optimization, and conversion tracking with live projects.",
  aboutHighlights: [
    "Industry-aligned SEM curriculum",
    "Hands-on training with live campaigns",
    "Career guidance & mentorship",
    "Google Ads tools & strategies covered",
    "1-on-1 doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Campaigns" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "SEM",
  frontEnd: ["Introduction to SEM", "Keyword Research for Ads", "Campaign Structure", "Ad Copywriting", "Bidding Strategies", "Quality Score Optimization"],
  backEnd: ["Search Ads & Display Ads", "Shopping Ads", "Video Ads (YouTube Ads)", "Remarketing Campaigns", "Conversion Tracking", "A/B Testing"],
  database: ["Google Ads Manager", "Google Analytics 4", "Keyword Planner", "Conversion Tracking Tools", "Live Campaign Projects", "Performance Optimization"],
  months: [
    { month: "Week 1-2", title: "SEM Fundamentals", topics: ["Introduction to SEM & PPC", "Keyword Research Basics", "Campaign Structure"] },
    { month: "Week 3-4", title: "Campaign Setup & Ads", topics: ["Campaign Setup", "Ad Creation Basics", "Ad Copywriting", "Targeting Strategies"] },
    { month: "Week 5-6", title: "Google Ads Mastery", topics: ["Search Campaigns", "Display Campaigns", "Bidding Strategies", "Budget Management"] },
    { month: "Week 7-8", title: "Optimization Techniques", topics: ["Quality Score Optimization", "A/B Testing", "Ad Performance Improvement", "CTR Optimization"] },
    { month: "Week 9-10", title: "Advanced Campaigns", topics: ["Remarketing Strategies", "Shopping Ads", "YouTube Ads", "Audience Targeting"] },
    { month: "Week 11-12", title: "Analytics & Reporting", topics: ["Google Analytics Setup", "Conversion Tracking", "Campaign Optimization", "Performance Reporting"] },
  ],
  ctaTitle: "Ready to Master SEM & Google Ads?",
  ctaSubtitle: "Learn from experts, run live campaigns, and build a career with our SEM training program.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <ShoppingBagIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with a beginner-friendly sem marketing course", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Upgrade your skills with advanced SEM training", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring PPC Experts", text: "Learn paid advertising from basics to advanced level", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Get into providing Google Ads services and push growth up in earnings.", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Run profitable ad campaigns and generate leads", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Promote content using paid ads and increase reach", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Google Ads Manager", color: "#4285F4" },
    { name: "Google Analytics 4", color: "#F4B400" },
    { name: "Keyword Planner", color: "#34A853" },
    { name: "Google Tag Manager", color: "#246FDB" },
    { name: "SEMrush", color: "#FF642D" },
    { name: "Ahrefs", color: "#007ACC" },
    { name: "Google Data Studio", color: "#4285F4" },
    { name: "Canva / Figma", color: "#7D2AE8" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "PPC Executive", rating: 5, text: "This SEM training helped me understand Google Ads practically. I started running campaigns confidently." },
    { name: "Rahul M.", role: "Digital Marketer", rating: 5, text: "Best sem marketing course! Trainers explained everything clearly with live campaigns." },
    { name: "Sneha A.", role: "Paid Ads Specialist", rating: 5, text: "I landed a job after completing this Google Ads course online." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from certified Google Ads professionals" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Campaigns", desc: "Work on real ad campaigns" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized learning experience" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
  certification: {
    badge: "Certification",
    title: "Earn a Certificate That Opens Doors.",
    subtitle: "Upon successful completion of the course and live campaigns, you receive an industry-recognized certification verified by Vihaan Innovations.",
    features: [
      { icon: <VerifiedUserIcon sx={{ color: "#0284c7" }} />, title: "Verified Credential", desc: "Shareable link to verify your skills with recruiters and on social platforms." },
      { icon: <WorkspacePremiumIcon sx={{ color: "#0284c7" }} />, title: "Industry Standard", desc: "Our curriculum is validated by industry experts to meet current market demands." },
      { icon: <ShareIcon sx={{ color: "#0284c7" }} />, title: "Social Ready", desc: "Add your certification directly to your LinkedIn profile with one click." }
    ]
  }
});

export const smmTrainingData = makeTrainingData({
  heroTitle: "Social Media Marketing Course in Bengaluru - Become an SMM Expert",
  heroSubtitle: "Master social media strategies with our industry-focused social media marketing training. Learn content creation, paid ads, audience targeting, and analytics with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Social Media Career Today",
  heroFormSubtitle: "Fill in your details and connect with our SMM experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Social Media Marketing Course - From Basics to Advanced",
  aboutBadge: "Specialized SMM Training",
  about1: "Our social media marketing course helps you master social platforms with a practical approach.",
  about2: "This social media marketing course online covers content strategy, paid ads, branding, and analytics with live projects.",
  aboutHighlights: [
    "Industry-aligned SMM curriculum",
    "Hands-on training with live campaigns",
    "Career guidance & mentorship",
    "Paid ads & organic growth strategies",
    "1-on-1 doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Campaigns" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "SMM",
  frontEnd: ["Introduction to SMM", "Platform Algorithms", "Content Planning", "Branding Basics", "Audience Targeting", "Engagement Strategies"],
  backEnd: ["Facebook & Instagram Ads", "LinkedIn Marketing", "YouTube Marketing", "Influencer Marketing", "Funnel Creation", "Retargeting Strategies"],
  database: ["Meta Ads Manager", "Canva / Figma", "Hootsuite / Buffer", "Google Analytics", "Live Campaign Projects", "Performance Tracking"],
  months: [
    { month: "Week 1-2", title: "SMM Fundamentals", topics: ["Introduction to Social Media", "Platform Overview", "Audience Research", "Content Planning"] },
    { month: "Week 3-4", title: "Content Strategy", topics: ["Content Strategy Development", "Content Calendar", "Engagement Planning", "Platform-Specific Content"] },
    { month: "Week 5-6", title: "Content Creation & Design", topics: ["Content Creation", "Visual Design Basics", "Tools for Design", "Branding Basics"] },
    { month: "Week 7-8", title: "Branding & Copywriting", topics: ["Copywriting Techniques", "Brand Voice & Identity", "Creative Content Strategy", "Audience Engagement"] },
    { month: "Week 9-10", title: "Paid Advertising", topics: ["Facebook & Instagram Ads", "Campaign Setup", "Targeting & Retargeting", "Budget Optimization"] },
    { month: "Week 11-12", title: "Analytics & Growth", topics: ["Performance Tracking", "Insights & Reporting", "Campaign Optimization", "Growth Strategies"] },
  ],
  ctaTitle: "Are you looking forward to building a career in social media marketing?",
  ctaSubtitle: "Learn from experts, run live campaigns, and grow your career with our social media marketing course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <CameraAltIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with a beginner-friendly smm course", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Upgrade your skills with advanced social media marketing training", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Social Media Managers", text: "Learn social media strategies from basics to advanced", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer SMM services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Promote your brand and generate leads", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Increase followers and engagement", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Meta Ads Manager", color: "#0668E1" },
    { name: "Canva Pro", color: "#00C4CC" },
    { name: "Hootsuite / Buffer", color: "#1e293b" },
    { name: "Google Analytics", color: "#F4B400" },
    { name: "YouTube Studio", color: "#FF0000" },
    { name: "LinkedIn Campaign Manager", color: "#0077B5" },
    { name: "Figma", color: "#F24E1E" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Social Media Executive", rating: 5, text: "This social media marketing course helped me grow my career and manage campaigns confidently." },
    { name: "Rahul M.", role: "Digital Marketer", rating: 5, text: "Best smm course with practical training and live projects." },
    { name: "Sneha A.", role: "SMM Specialist", rating: 5, text: "After completing this social media marketing course, I secured freelance clients." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced social media professionals" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Campaigns", desc: "Work on real-time social media campaigns" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
  certification: {
    badge: "Certification",
    title: "Earn a Certificate That Opens Doors.",
    subtitle: "Upon successful completion of the course and projects, you receive an industry-recognized certification verified by Vihaan Innovations.",
    features: [
      { icon: <VerifiedUserIcon sx={{ color: "#0284c7" }} />, title: "Verified Credential", desc: "Shareable link to verify your skills with recruiters and on social platforms." },
      { icon: <WorkspacePremiumIcon sx={{ color: "#0284c7" }} />, title: "Industry Standard", desc: "Our curriculum is validated by industry experts to meet current market demands." },
      { icon: <ShareIcon sx={{ color: "#0284c7" }} />, title: "Social Ready", desc: "Add your certification directly to your LinkedIn profile with one click." }
    ]
  }
});

export const emailMarketingTrainingData = makeTrainingData({
  heroTitle: "Email Marketing Course in Bengaluru - Master Campaigns & Automation",
  heroSubtitle: "Learn to create high-converting email campaigns with our expert-led email marketing training. Master automation, segmentation, copywriting, and analytics with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Email Marketing Career Today",
  heroFormSubtitle: "Fill in your details and connect with our email marketing experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Email Marketing Course - From Basics to Advanced",
  aboutBadge: "Specialized Email Marketing Training",
  about1: "Our email marketing course helps you learn email marketing from scratch with a practical approach.",
  about2: "This email marketing course online covers campaign creation, automation, segmentation, and analytics with live projects.",
  aboutHighlights: [
    "Industry-aligned email marketing curriculum",
    "Hands-on training with live campaigns",
    "Career guidance & mentorship",
    "Automation & advanced strategies covered",
    "1-on-1 doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Campaigns" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "Email Marketing",
  frontEnd: ["Introduction to Email Marketing", "List Building Strategies", "Email Copywriting", "Campaign Planning", "Email Design Basics", "Deliverability Essentials"],
  backEnd: ["Email Automation Workflows", "Segmentation & Personalization", "A/B Testing", "Drip Campaigns", "Conversion Optimization", "Customer Journey Mapping"],
  database: ["Mailchimp", "HubSpot Email Marketing", "Sendinblue (Brevo)", "ConvertKit", "ActiveCampaign", "Live Campaign Projects"],
  months: [
    { month: "Week 1-2", title: "Fundamentals", topics: ["Introduction to Email Marketing", "List Building", "Email Strategy Basics", "Campaign Setup"] },
    { month: "Week 3-4", title: "Copywriting & Planning", topics: ["Email Copywriting", "Subject Lines Optimization", "Content Planning", "Email Structure"] },
    { month: "Week 5-6", title: "Campaign Creation", topics: ["Email Design", "Templates & Layouts", "Segmentation", "Personalization"] },
    { month: "Week 7-8", title: "Testing & Optimization", topics: ["A/B Testing", "Performance Metrics", "Open Rate Optimization", "CTR Improvement"] },
    { month: "Week 9-10", title: "Automation", topics: ["Automation Workflows", "Drip Campaigns", "Customer Journey Mapping", "Trigger based Emails"] },
    { month: "Week 11-12", title: "Analytics & Reporting", topics: ["Performance Tracking", "Conversion Optimization", "Campaign Reporting", "Email Strategy Improvement"] },
  ],
  ctaTitle: "Do you want to master email marketing and advance your career?",
  ctaSubtitle: "Learn from experts, run live campaigns, and grow your career with our email marketing course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career and learn email marketing full course step by step", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Upgrade your skills with advanced email marketing training", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Digital Marketers", text: "Learn email strategies from basics to advanced", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer email marketing services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Build customer relationships and increase sales", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Engage your audience with email campaigns", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Mailchimp", color: "#FFE01B" },
    { name: "HubSpot", color: "#FF7A59" },
    { name: "Sendinblue (Brevo)", color: "#0092FF" },
    { name: "ActiveCampaign", color: "#356AE6" },
    { name: "ConvertKit", color: "#FF5A5F" },
    { name: "Google Analytics", color: "#F4B400" },
    { name: "Zapier", color: "#FF4A00" },
    { name: "Canva", color: "#00C4CC" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Email Marketing Executive", rating: 5, text: "This email marketing course has increased my very practical understanding of campaigns and automation to a new high." },
    { name: "Rahul M.", role: "Digital Marketer", rating: 5, text: "The best email marketing training along with real projects and tools." },
    { name: "Sneha A.", role: "Email Marketing Specialist", rating: 5, text: "I started freelancing after completing this email marketing course online." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced email marketing professionals" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Campaigns", desc: "Work on real-time email campaigns" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
  certification: {
    badge: "Certification",
    title: "Earn a Certificate That Opens Doors.",
    subtitle: "Upon successful completion of the course and projects, you receive an industry-recognized certification verified by Vihaan Innovations.",
    features: [
      { icon: <VerifiedUserIcon sx={{ color: "#0284c7" }} />, title: "Verified Credential", desc: "Shareable link to verify your skills with recruiters and on social platforms." },
      { icon: <WorkspacePremiumIcon sx={{ color: "#0284c7" }} />, title: "Industry Standard", desc: "Our curriculum is validated by industry experts to meet current market demands." },
      { icon: <ShareIcon sx={{ color: "#0284c7" }} />, title: "Social Ready", desc: "Add your certification directly to your LinkedIn profile with one click." }
    ]
  }
});

export const contentMarketingTrainingData = makeTrainingData({
  heroTitle: "Content Marketing Training in Bengaluru - Build Powerful Content Strategies",
  heroSubtitle: "Master storytelling, SEO content, and brand growth with our expert-led content marketing course. Learn content creation, distribution, and performance tracking with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Content Marketing Career Today",
  heroFormSubtitle: "Fill in your details and connect with our content marketing experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Content Marketing Course - The Basics to Expert Knowledge",
  aboutBadge: "Specialized Content Marketing Training",
  about1: "Our content marketing training helps you create impactful content that drives traffic and engagement.",
  about2: "This content marketing course online covers strategy, content creation, SEO writing, and distribution with live projects.",
  aboutHighlights: [
    "Industry-aligned content marketing curriculum",
    "Hands-on training with real-world projects",
    "SEO content & storytelling techniques",
    "Content strategy for business growth",
    "1-on-1 mentorship sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "Content Marketing",
  frontEnd: ["Content Marketing Fundamentals", "Audience Research", "Content Planning", "Blogging Basics", "SEO Content Writing", "Content Calendar"],
  backEnd: ["Storytelling Techniques", "Content Funnels", "Copywriting & Persuasion", "Content Distribution Strategies", "Content for Social Media", "Conversion-Focused Content"],
  database: ["Google Docs / Notion", "Grammarly", "Canva", "WordPress", "SEO Tools (Ahrefs, SEMrush)", "Live Content Projects"],
  months: [
    { month: "Week 1-2", title: "Fundamentals", topics: ["Introduction to Content Marketing", "Audience Research", "Content Planning", "Blogging Basics"] },
    { month: "Week 3-4", title: "Content Strategy", topics: ["Content Strategy Development", "Content Calendar", "Topic Research", "Audience Targeting"] },
    { month: "Week 5-6", title: "Content Creation", topics: ["SEO Content Writing", "Copywriting", "Storytelling", "Content Formatting"] },
    { month: "Week 7-8", title: "Advanced Content", topics: ["Blog Optimization", "Long Form Content", "Content Repurposing", "Engagement Techniques"] },
    { month: "Week 9-10", title: "Distribution", topics: ["Social Media Content", "Email Content", "Content Promotion", "Content Funnels"] },
    { month: "Week 11-12", title: "Analytics & Optimization", topics: ["Content Performance Tracking", "SEO Optimization", "Conversion Tracking", "Strategy Improvement"] },
  ],
  ctaTitle: "Ready to dominate content marketing and boost your career?",
  ctaSubtitle: "Learn from experts, work on real projects, and build a career with our content marketing course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with a beginner-friendly content marketing course online", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Upgrade your skills with advanced content strategies", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Content Writers", text: "Learn content creation from basics to advanced", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer content marketing services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Use content marketing for business growth and lead generation", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Build your brand and increase audience engagement", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Google Docs", color: "#4285F4" },
    { name: "Notion", color: "#000000" },
    { name: "Grammarly", color: "#15C39A" },
    { name: "Canva", color: "#00C4CC" },
    { name: "WordPress", color: "#21759B" },
    { name: "Ahrefs", color: "#007ACC" },
    { name: "SEMrush", color: "#FF642D" },
    { name: "Google Analytics", color: "#F4B400" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Content Writer", rating: 5, text: "This content marketing course helped me improve my writing and land clients." },
    { name: "Rahul M.", role: "Digital Marketer", rating: 5, text: "Best content marketing training with practical projects and strategies." },
    { name: "Sneha A.", role: "Content Strategist", rating: 5, text: "I have learned to effectively use content marketing for business growth." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced content marketing professionals" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Work on real-time content projects" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
  certification: {
    badge: "Certification",
    title: "Earn a Certificate That Opens Doors.",
    subtitle: "Upon successful completion of the course and projects, you receive an industry-recognized certification verified by Vihaan Innovations.",
    features: [
      { icon: <VerifiedUserIcon sx={{ color: "#0284c7" }} />, title: "Verified Credential", desc: "Shareable link to verify your skills with recruiters and on social platforms." },
      { icon: <WorkspacePremiumIcon sx={{ color: "#0284c7" }} />, title: "Industry Standard", desc: "Our curriculum is validated by industry experts to meet current market demands." },
      { icon: <ShareIcon sx={{ color: "#0284c7" }} />, title: "Social Ready", desc: "Add your certification directly to your LinkedIn profile with one click." }
    ]
  }
});

// ── Software Training ──
export const webDevReactTrainingData = makeTrainingData({
  heroTitle: "Web Designing Course in Bengaluru - Learn React & Build Modern Websites",
  heroSubtitle: "Master frontend and full-stack basics with our expert-led web development online training. Learn HTML, CSS, JavaScript, and React to build responsive, high-performance websites.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Web Development Career Today",
  heroFormSubtitle: "Fill in your details and connect with our expert trainers.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Web Designing Course - From Basics to Advanced with React",
  aboutBadge: "Specialized Web Development Training",
  about1: "Our web designing course helps you build modern, responsive websites with a practical approach.",
  about2: "This web development online training covers HTML, CSS, JavaScript, and react course online modules with real-time projects.",
  aboutHighlights: [
    "Industry-aligned web development curriculum",
    "Hands-on training with live projects",
    "Learn modern frameworks like React",
    "Build responsive and dynamic websites",
    "1-on-1 mentorship & doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "3 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "3 Months", courseLabel: "Web Design & Development (React)",
  frontEnd: ["HTML5 & CSS3", "Responsive Design", "Flexbox & Grid", "UI/UX Basics", "Website Layout Design", "Cross-Browser Compatibility"],
  backEnd: ["JavaScript Fundamentals", "ES6+ Concepts", "DOM Manipulation", "React Basics", "Components & Props", "State Management", "API Integration"],
  database: ["Visual Studio Code", "Git & GitHub", "Figma / Adobe XD", "Chrome DevTools", "Deployment (Netlify/Vercel)", "Live Website Projects"],
  months: [
    { month: "Week 1-2", title: "HTML and CSS", topics: ["HTML Structure", "CSS Styling", "Layout Basics", "UI Fundamentals"] },
    { month: "Week 3-4", title: "Responsive Design", topics: ["Responsive Layouts", "Flexbox and Grid", "Media Queries", "Mobile Friendly Design"] },
    { month: "Week 5-6", title: "JavaScript Basics", topics: ["JavaScript Fundamentals", "Variables and Functions", "Events Handling", "DOM Basics"] },
    { month: "Week 7-8", title: "Advanced JavaScript", topics: ["ES6 Concepts", "Array Methods", "Async JavaScript", "API Basics"] },
    { month: "Week 9-10", title: "React Fundamentals", topics: ["React Basics", "Components", "Props and State", "Hooks"] },
    { month: "Week 11-12", title: "Advanced React and Projects", topics: ["Routing", "API Integration", "Project Development", "Deployment"] },
  ],
  ctaTitle: "Ready to Become a Web Developer with React?",
  ctaSubtitle: "Our Web Designing Course will help you grow through learning from Experts, working on real projects, and creating your career.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with beginner-friendly web designing courses", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Developers", text: "Learn modern web development with react course online", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Working Professionals", text: "Upgrade your skills with web development online training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Build websites and grow your freelance career", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Create and manage your own websites", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Designers", text: "Transition into web development and UI design", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Visual Studio Code", color: "#007ACC" },
    { name: "Git & GitHub", color: "#F05032" },
    { name: "Figma / Adobe XD", color: "#F24E1E" },
    { name: "Chrome DevTools", color: "#4285F4" },
    { name: "Netlify", color: "#00C7B7" },
    { name: "Vercel", color: "#000000" },
    { name: "Firebase", color: "#FFCA28" },
    { name: "Postman", color: "#FF6C37" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Frontend Developer", rating: 5, text: "This web designing course helped me build real projects and gain confidence." },
    { name: "Rahul M.", role: "Web Developer", rating: 5, text: "An exceptional React course that combines practical exercises with true understanding." },
    { name: "Sneha A.", role: "Software Engineer", rating: 5, text: "I got landed up after the successful completion of this web development online training course." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced web developers" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real-world websites and applications" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const javaTrainingData = makeTrainingData({
  heroTitle: "Java Course in Bengaluru - Master Core Java & Build Real Applications",
  heroSubtitle: "Learn programming fundamentals and backend development with our expert-led java core training. Master object-oriented programming, data structures, and real-world application development.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Java Development Career Today",
  heroFormSubtitle: "Fill in your details and connect with our Java experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Java Course - From Basics to Advanced Programming",
  aboutBadge: "Specialized Java Training",
  about1: "Our java course helps you learn programming from scratch with a strong foundation in Java.",
  about2: "This core java course online covers OOP concepts, collections, exception handling, and real-time projects.",
  aboutHighlights: [
    "Industry-aligned Java curriculum",
    "Hands-on coding with real-time projects",
    "Strong focus on core Java concepts",
    "Backend development fundamentals",
    "1-on-1 mentorship & doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "3 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "3 Months", courseLabel: "Java Training",
  frontEnd: ["Introduction to Java", "Data Types & Variables", "Operators & Control Statements", "Loops & Functions", "Arrays & Strings", "Object-Oriented Programming (OOP)"],
  backEnd: ["Collections Framework", "Exception Handling", "File Handling", "Multithreading", "JDBC Basics", "Debugging Techniques"],
  database: ["IntelliJ IDEA / Eclipse", "Java Development Kit (JDK)", "MySQL Integration", "Git & GitHub", "Debugging Tools", "Real-Time Projects"],
  months: [
    { month: "Week 1-2", title: "Java Fundamentals", topics: ["Introduction to Java", "Variables and Data Types", "Operators", "Control Statements"] },
    { month: "Week 3-4", title: "OOP Concepts", topics: ["Classes and Objects", "Inheritance", "Polymorphism", "Encapsulation"] },
    { month: "Week 5-6", title: "Core Java Advanced", topics: ["Collections Framework", "Exception Handling", "File Handling", "Debugging Basics"] },
    { month: "Week 7-8", title: "Multithreading and APIs", topics: ["Multithreading Concepts", "Thread Management", "Working with APIs", "Performance Basics"] },
    { month: "Week 9-10", title: "Database Integration", topics: ["JDBC Basics", "SQL Integration", "CRUD Operations", "Mini Project"] },
    { month: "Week 11-12", title: "Final Project Development", topics: ["Project Planning", "Application Development", "Testing and Debugging", "Project Deployment Basics"] },
  ],
  ctaTitle: "Ready to Become a Java Developer?",
  ctaSubtitle: "Learn from experts, build real applications, and grow your career with our java course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your programming journey with beginner-friendly java core training", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Developers", text: "Learn backend development with core java course online", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Working Professionals", text: "Upgrade your skills with structured training for java", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Career Switchers", text: "Move into software development roles", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Build Java-based applications and projects", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Tech Enthusiasts", text: "Learn programming logic and problem-solving", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "IntelliJ IDEA", color: "#000000" },
    { name: "Eclipse IDE", color: "#2C2255" },
    { name: "Java Development Kit (JDK)", color: "#007396" },
    { name: "MySQL", color: "#4479A1" },
    { name: "Git & GitHub", color: "#F05032" },
    { name: "Postman", color: "#FF6C37" },
    { name: "Apache Tomcat", color: "#F8981D" },
    { name: "Maven", color: "#C71A36" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Software Developer", rating: 5, text: "This java course cleared my clear understanding of programming concepts." },
    { name: "Rahul M.", role: "Backend Developer", rating: 5, text: "Best core java course online with hands-on coding and projects." },
    { name: "Sneha A.", role: "Java Developer", rating: 5, text: "I got placed after completing this training for java." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced Java developers" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real-world applications" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const pythonTrainingData = makeTrainingData({
  heroTitle: "Python Course in Bengaluru - Learn Programming & AI Fundamentals",
  heroSubtitle: "Master programming with our expert-led python course training. Learn Python basics, data handling, automation, and AI concepts with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Python Career Today",
  heroFormSubtitle: "Fill in your details and connect with our Python experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Python Course - From Basics to AI Applications",
  aboutBadge: "Specialized Python Training",
  about1: "Our python course helps you learn programming from scratch with a practical approach.",
  about2: "This python course learning program covers automation, data handling, and ai python training with real-time projects.",
  aboutHighlights: [
    "Industry-aligned Python curriculum",
    "Hands-on coding with real-time projects",
    "Introduction to AI and automation",
    "Data handling and scripting skills",
    "1-on-1 mentorship & doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "3 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "3 Months", courseLabel: "Python Training",
  frontEnd: ["Introduction to Python", "Variables & Data Types", "Operators & Control Flow", "Functions & Modules", "Lists, Tuples, Dictionaries", "File Handling"],
  backEnd: ["Object-Oriented Programming", "Exception Handling", "Working with APIs", "Data Processing", "Automation Scripts", "Debugging Techniques"],
  database: ["Introduction to AI Concepts", "Basic Machine Learning", "Data Analysis Basics", "Python Libraries (NumPy, Pandas)", "Mini AI Projects", "Real-Time Applications"],
  months: [
    { month: "Week 1-2", title: "Python Fundamentals", topics: ["Variables and Data Types", "Operators", "Control Statements", "Basic Programs"] },
    { month: "Week 3-4", title: "Functions and Data Structures", topics: ["Functions", "Lists Tuples Dictionaries", "String Handling", "Problem Solving"] },
    { month: "Week 5-6", title: "OOP Concepts", topics: ["Classes and Objects", "Inheritance", "Polymorphism", "Encapsulation"] },
    { month: "Week 7-8", title: "Advanced Python", topics: ["File Handling", "Exception Handling", "Working with APIs", "Debugging"] },
    { month: "Week 9-10", title: "Automation and Data", topics: ["Automation Scripts", "Data Processing", "NumPy Basics", "Pandas Basics"] },
    { month: "Week 11-12", title: "AI and Final Project", topics: ["AI Basics", "Data Analysis", "Mini Project", "Final Project Development"] },
  ],
  ctaTitle: "Ready to Start Your Python Career?",
  ctaSubtitle: "Learn from experts, build real projects, and grow your career with our python course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your journey with beginner-friendly python course learning", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Developers", text: "Learn programming and automation with Python", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Working Professionals", text: "Upgrade your skills with python course training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Data Enthusiasts", text: "Learn data handling and AI basics", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Build Python-based applications and scripts", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Tech Enthusiasts", text: "Learn problem-solving and programming logic", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Python (IDLE / VS Code)", color: "#3776AB" },
    { name: "Jupyter Notebook", color: "#F37626" },
    { name: "PyCharm", color: "#000000" },
    { name: "NumPy", color: "#013243" },
    { name: "Pandas", color: "#150458" },
    { name: "Git & GitHub", color: "#F05032" },
    { name: "APIs & Postman", color: "#FF6C37" },
    { name: "Matplotlib", color: "#11557C" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Python Developer", rating: 5, text: "This python course helped me understand programming and automation clearly." },
    { name: "Rahul M.", role: "Software Developer", rating: 5, text: "Best python course training with practical projects and AI basics." },
    { name: "Sneha A.", role: "Python Engineer", rating: 5, text: "I started working on real projects after completing this python course learning." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced Python developers" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real-world applications" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const mobileAppTrainingData = makeTrainingData({
  heroTitle: "Mobile App Development: Create Android & iOS apps in Bengaluru.",
  heroSubtitle: "Learn to design and develop mobile applications with our expert-led mobile app development course online. Master Android, iOS, and cross-platform app development with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Mobile App Development Career Today",
  heroFormSubtitle: "Fill in your details and connect with our mobile development experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Mobile Development Course - From Basics to Advanced App Development",
  aboutBadge: "Specialized Mobile Development Training",
  about1: "Our mobile development course helps you learn app development from scratch with a practical approach.",
  about2: "This mobile app development course online covers Android, iOS, and cross-platform technologies with live projects.",
  aboutHighlights: [
    "Industry-aligned mobile development curriculum",
    "Hands-on training with real app projects",
    "Android & iOS development covered",
    "UI/UX design for mobile apps",
    "1-on-1 mentorship & doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "4 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Apps" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "4 Months", courseLabel: "Android & iOS Training",
  frontEnd: ["Java/Kotlin Basics", "Android Studio Setup", "UI Design for Android", "Activities & Fragments", "API Integration", "App Deployment"],
  backEnd: ["Swift Basics", "Xcode Setup", "UI Design for iOS", "Navigation & Layouts", "API Integration", "App Store Deployment"],
  database: ["React Native / Flutter Basics", "App Architecture", "Database Integration", "Firebase Integration", "Live App Projects", "Debugging & Testing"],
  months: [
    { month: "Week 1-2", title: "Programming Fundamentals", topics: ["Java Kotlin or Swift Basics", "Programming Concepts", "UI Basics", "Development Environment Setup"] },
    { month: "Week 3-4", title: "Android Basics", topics: ["Android Studio Setup", "UI Design", "Layouts and Navigation", "App Components"] },
    { month: "Week 5-6", title: "Advanced Android Development", topics: ["API Integration", "Data Handling", "App Logic", "Debugging"] },
    { month: "Week 7-8", title: "iOS Development Basics", topics: ["Swift Programming", "Xcode Setup", "UI UX Design", "Navigation"] },
    { month: "Week 9-10", title: "Advanced iOS Development", topics: ["API Integration", "App Features", "Performance Optimization", "Testing"] },
    { month: "Week 11-12", title: "Projects and Deployment", topics: ["Cross Platform Basics", "Firebase Integration", "App Testing", "Final Project", "Deployment and App Store Submission"] },
  ],
  ctaTitle: "Ready to Build Your Mobile App Development Career?",
  ctaSubtitle: "Learn from experts, build real apps, and grow your career with our mobile development course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with beginner-friendly app development course android", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring App Developers", text: "Learn mobile app development from basics to advanced", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Working Professionals", text: "Upgrade your skills with android development training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "iOS Enthusiasts", text: "Build iOS apps with ios development training", accent: "#b45309", bg: "#fffbeb" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Create mobile apps and grow your income", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Entrepreneurs", text: "Build and launch your own mobile apps", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Android Studio", color: "#3DDC84" },
    { name: "Xcode", color: "#147EFB" },
    { name: "Firebase", color: "#FFCA28" },
    { name: "React Native / Flutter", color: "#61DAFB" },
    { name: "Git & GitHub", color: "#F05032" },
    { name: "Postman", color: "#FF6C37" },
    { name: "Figma", color: "#F24E1E" },
    { name: "VS Code", color: "#007ACC" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Android Developer", rating: 5, text: "This mobile development course helped me build real Android apps." },
    { name: "Rahul M.", role: "App Developer", rating: 5, text: "Online mobile app development course with real-time projects." },
    { name: "Sneha A.", role: "iOS Developer", rating: 5, text: "I built my first app after iOS development training." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced app developers" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real mobile applications" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const softwareTestingTrainingData = makeTrainingData({
  heroTitle: "Automation Testing Training in Bengaluru - Master Manual & Selenium Testing",
  heroSubtitle: "Learn software testing from basics to advanced with our expert-led manual automation testing course. Master manual testing, Selenium automation, and real-time testing projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Testing Career Today",
  heroFormSubtitle: "Fill in your details and connect with our testing experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Automation Testing Training - From Manual to Selenium",
  aboutBadge: "Specialized Testing Training",
  about1: "Our automation testing training helps you understand software testing from scratch with a practical approach.",
  about2: "This manual testing course online covers test cases, bug tracking, and selenium automation testing course modules with real-time projects.",
  aboutHighlights: [
    "Industry-aligned testing curriculum",
    "Hands-on training with live projects",
    "Manual & automation testing covered",
    "Selenium and real-time tools included",
    "1-on-1 mentorship & doubt sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "3 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "3 Months", courseLabel: "Manual & Automation Testing",
  frontEnd: ["Software Testing Basics", "SDLC & STLC", "Test Case Writing", "Bug Reporting", "Functional Testing", "Regression Testing"],
  backEnd: ["Introduction to Automation", "Selenium WebDriver", "Test Scripts Development", "TestNG Framework", "Maven Integration", "Automation Framework Design"],
  database: ["Selenium WebDriver", "TestNG", "JIRA", "Postman", "Git & GitHub", "Real-Time Testing Projects"],
  months: [
    { month: "Week 1-2", title: "Testing Fundamentals", topics: ["Testing Basics", "SDLC and STLC", "Types of Testing", "Testing Lifecycle"] },
    { month: "Week 3-4", title: "Manual Testing", topics: ["Test Case Design", "Test Scenarios", "Bug Tracking", "Documentation"] },
    { month: "Week 5-6", title: "Automation Basics", topics: ["Introduction to Automation", "Selenium WebDriver", "Test Scripts", "Element Handling"] },
    { month: "Week 7-8", title: "Automation Framework", topics: ["Framework Basics", "TestNG", "Data Driven Testing", "Debugging"] },
    { month: "Week 9-10", title: "Advanced Testing", topics: ["Automation Framework Design", "API Testing", "Postman Basics", "Performance Basics"] },
    { month: "Week 11-12", title: "CI CD and Projects", topics: ["CI CD Basics", "Jenkins Integration", "Final Project", "Reporting and Optimization"] },
  ],
  ctaTitle: "Ready to Start Your Career in Software Testing?",
  ctaSubtitle: "Learn from experts, practice real-time testing, and build your career with our automation testing training.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with beginner-friendly manual testing course online", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Test Engineers", text: "Learn software testing from basics to advanced", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Working Professionals", text: "Upgrade your skills with automation testing training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <CodeIcon sx={{ fontSize: 28 }} />, label: "Developers", text: "Learn testing to improve code quality", accent: "#b45309", bg: "#fffbeb" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Career Switchers", text: "Move into software testing roles", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Tech Enthusiasts", text: "Learn testing tools and frameworks", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Selenium WebDriver", color: "#43B02A" },
    { name: "TestNG", color: "#FF7F00" },
    { name: "JIRA", color: "#0052CC" },
    { name: "Postman", color: "#FF6C37" },
    { name: "Git & GitHub", color: "#F05032" },
    { name: "Maven", color: "#C71A36" },
    { name: "Jenkins", color: "#D24939" },
    { name: "Eclipse / IntelliJ", color: "#2C2255" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "QA Engineer", rating: 5, text: "This automation testing training helped me understand both manual and Selenium testing clearly." },
    { name: "Rahul M.", role: "Test Engineer", rating: 5, text: "Best selenium automation testing course with hands-on projects." },
    { name: "Sneha A.", role: "Automation Tester", rating: 5, text: "I got placed after completing this manual automation testing course." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced QA professionals" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Work on real-time testing scenarios" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

// ── Animation Training ──
export const graphicDesigningTrainingData = makeTrainingData({
  heroTitle: "Graphic Design Course in Bengaluru - Learn Creative Design & Branding",
  heroSubtitle: "Master visual design with our expert-led graphic design training. Learn branding, typography, UI design, and creative tools with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Graphic Designing Career Today",
  heroFormSubtitle: "Fill in your details and connect with our design experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Graphic Design Course - From Basics to Advanced",
  aboutBadge: "Specialized Graphic Design Training",
  about1: "Our graphic design course helps you learn graphic design from scratch with a practical approach.",
  about2: "This graphic design course online covers branding, typography, and visual design with real-time projects.",
  aboutHighlights: [
    "Industry-aligned graphic design curriculum",
    "Hands-on training with live design projects",
    "Branding and creative design techniques",
    "UI design fundamentals included",
    "1-on-1 mentorship & feedback sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "Graphic Designing",
  frontEnd: ["Principles of Design", "Color Theory", "Typography", "Layout & Composition", "Visual Hierarchy", "Branding Basics"],
  backEnd: ["Logo Design", "Social Media Creatives", "UI Design Basics", "Advertising Design", "Print Design", "Portfolio Creation"],
  database: ["Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign", "Canva", "Figma", "Live Design Projects"],
  months: [
    { month: "Week 1-2", title: "Design Fundamentals", topics: ["Principles of Design", "Typography", "Color Theory", "Layout Design"] },
    { month: "Week 3-4", title: "Advanced Design", topics: ["Branding and Logo Design", "Social Media Creatives", "UI Basics", "Visual Design Techniques"] },
    { month: "Week 5-6", title: "Portfolio and Projects", topics: ["Portfolio Development", "Real Design Projects", "Case Study Creation", "Presentation Skills"] },
  ],
  ctaTitle: "Ready to Start Your Creative Career in Graphic Design?",
  ctaSubtitle: "Learn from experts, build real designs, and grow your career with our graphic design course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with beginner-friendly graphic designing courses near me", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Designers", text: "Learn creative design from basics to advanced", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Enhance your skills with graphic design training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer design services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Create branding and marketing materials", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Design engaging visuals for social media", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Adobe Photoshop", color: "#31A8FF" },
    { name: "Adobe Illustrator", color: "#FF9A00" },
    { name: "Adobe InDesign", color: "#FF3366" },
    { name: "Canva", color: "#00C4CC" },
    { name: "Figma", color: "#F24E1E" },
    { name: "CorelDRAW", color: "#008F41" },
    { name: "Adobe XD", color: "#FF61F6" },
    { name: "Lightroom", color: "#31A8FF" },
  ],
  testimonialsList: [
    { name: "Priya S.", role: "Graphic Designer", rating: 5, text: "The graphic design class assisted in building my portfolio and freelance clients." },
    { name: "Rahul M.", role: "Visual Designer", rating: 5, text: "Best graphic design training with practical projects and creative guidance." },
    { name: "Sneha A.", role: "UI Designer", rating: 5, text: "After joining the graphic design course, I learned about branding and design." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced designers" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Work on real design projects" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const twoDAnimationTrainingData = makeTrainingData({
  heroTitle: "2D Animation Course in Bengaluru - Master Character Design & Animation",
  heroSubtitle: "Learn to create stunning 2D animations with our expert-led 2D animation course. Master character design, storyboarding, and animation techniques with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your 2D Animation Career Today",
  heroFormSubtitle: "Fill in your details and connect with our animation experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "2D Animation Course - From Basics to Professional Animation",
  aboutBadge: "Specialized 2D Animation Training",
  about1: "Our 2D animation course helps you learn animation from scratch with a practical approach.",
  about2: "This 2D animation online course covers character design, rigging, and frame-by-frame animation with real-time projects.",
  aboutHighlights: [
    "Industry-aligned animation curriculum",
    "Hands-on training with live animation projects",
    "Character design and rigging techniques",
    "Storyboarding and visual storytelling",
    "1-on-1 mentorship & feedback sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "3 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "3 Months", courseLabel: "2D Animation",
  frontEnd: ["Principles of Animation", "Character Design", "Storyboarding", "Background Design", "Color Theory", "Layout & Composition"],
  backEnd: ["Character Rigging", "Frame-by-Frame Animation", "Lip Syncing", "Transitions & Effects", "Digital Coloring", "Final Video Production"],
  database: ["Adobe Animate", "Adobe After Effects", "Adobe Photoshop", "Adobe Illustrator", "Audacity", "Real-Time Animation Projects"],
  months: [
    { month: "Week 1-2", title: "Animation Fundamentals", topics: ["Principles of Animation", "History of Animation", "Tools Introduction", "Basic Motion"] },
    { month: "Week 3-4", title: "Character Design", topics: ["Character Proportions", "Character Rigging", "Expression and Pose", "Anatomy Basics"] },
    { month: "Week 5-6", title: "Storyboarding and Layout", topics: ["Storyboarding Techniques", "Layout Design", "Background Creation", "Visual Planning"] },
    { month: "Week 7-8", title: "Basic 2D Animation", topics: ["Frame by Frame Animation", "Tweening Techniques", "Lip Sync", "Timing and Spacing"] },
    { month: "Week 9-10", title: "Advanced Animation", topics: ["Advanced Rigging", "Character Walk Cycles", "Background Animation", "Digital Coloring"] },
    { month: "Week 11-12", title: "Project and Production", topics: ["Digital Compositing", "Audio Integration", "Final Video Production", "Portfolio Building"] },
  ],
  ctaTitle: "Ready to Become a 2D Animator?",
  ctaSubtitle: "Learn from experts, build real animations, and grow your career with our 2D animation course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with our easy-to-learn 2D animation course for beginners", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Animators", text: "Learn 2D animation from basics to advanced level", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Graphic Designers", text: "Upgrade your skills with 2D animation training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer animation services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Entrepreneurs", text: "Create animated content for your business", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Design 2D characters and animations for social media", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Adobe Animate", color: "#ED2224" },
    { name: "Adobe After Effects", color: "#9999FF" },
    { name: "Adobe Photoshop", color: "#31A8FF" },
    { name: "Adobe Illustrator", color: "#FF9A00" },
    { name: "Toon Boom Harmony", color: "#000000" },
    { name: "Audacity", color: "#0000CC" },
    { name: "TVPaint", color: "#660099" },
    { name: "Storyboard Pro", color: "#003366" },
  ],
  testimonialsList: [
    { name: "Arjun K.", role: "Alumni", rating: 5, text: "The best 2D animation course for learning character design and rigging." },
    { name: "Meera R.", role: "Alumni", rating: 5, text: "Practical 2D animation training with hands-on projects and exercises." },
    { name: "Kiran P.", role: "Alumni", rating: 5, text: "I started working on real projects after finishing the 2D animation online course." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced 2D animators" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real 2D animations" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const threeDAnimationTrainingData = makeTrainingData({
  heroTitle: "3D Animation Course in Bengaluru - Learn 3D Modeling & Animation",
  heroSubtitle: "Master 3D animation with our expert-led 3D animation training. Learn 3D modeling, texturing, rigging, and lighting with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your 3D Animation Career Today",
  heroFormSubtitle: "Fill in your details and connect with our 3D experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "3D Animation Course - From Basics to Advanced 3D Animation",
  aboutBadge: "Specialized 3D Animation Training",
  about1: "Our 3D animation course helps you learn 3D design from scratch with a practical approach.",
  about2: "This 3D animation online course covers 3D modeling, rigging, and realistic animation with real-time projects.",
  aboutHighlights: [
    "Industry-aligned 3D curriculum",
    "Hands-on training with live 3D projects",
    "3D modeling and texturing techniques",
    "Rigging and realistic animation covered",
    "1-on-1 mentorship & feedback sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "4 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "4 Months", courseLabel: "3D Animation",
  frontEnd: ["Introduction to 3D", "3D Modeling Basics", "Character Design", "Environment Design", "Texturing Basics", "UV Unwrapping"],
  backEnd: ["3D Rigging Fundamentals", "Keyframe Animation", "Lighting & Rendering", "Liquid & Particle FX", "Digital Sculpting", "Final Video Rendering"],
  database: ["Autodesk Maya", "Blender", "ZBrush", "Substance Painter", "KeyShot", "Real-Time 3D Projects"],
  months: [
    { month: "Week 1-2", title: "Introduction to 3D", topics: ["3D Pipeline Overview", "Interface and Navigation", "Basic Modeling", "Modifiers and Tools"] },
    { month: "Week 3-4", title: "Character and Asset Modeling", topics: ["Prop Modeling", "Character Proportions", "Geometry Basics", "Topology Optimization"] },
    { month: "Week 5-6", title: "Texturing and UV Unwrapping", topics: ["UV Basics", "Material Assignment", "PBR Texturing", "Texture Painting"] },
    { month: "Week 7-8", title: "3D Rigging", topics: ["Joint Placement", "Skinning Techniques", "IK and FK Basics", "Facial Rigging"] },
    { month: "Week 9-10", title: "3D Animation Principles", topics: ["Walk Cycle", "Weight and Balance", "Character Posing", "Timing and Easing"] },
    { month: "Week 11-12", title: "Lighting and Rendering", topics: ["Lighting Basics", "Camera Setup", "Rendering Engines", "Final Output and Composite"] },
  ],
  ctaTitle: "Ready to Become a 3D Animator?",
  ctaSubtitle: "Learn from experts, build real 3D projects, and grow your career with our 3D animation course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with our 3D animation course for beginners in Bangalore", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring 3D Animators", text: "Learn 3D animation from basics to advanced level", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Graphic Designers", text: "Transition into 3D with 3D animation training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer 3D services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Architecture Enthusiasts", text: "Learn 3D modeling and visualization", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Design 3D graphics and animations for media", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Autodesk Maya", color: "#31A8FF" },
    { name: "Blender", color: "#FF9A00" },
    { name: "ZBrush", color: "#000000" },
    { name: "Substance Painter", color: "#FF3366" },
    { name: "Maxon Cinema 4D", color: "#003366" },
    { name: "Adobe After Effects", color: "#9999FF" },
    { name: "Arnold / V-Ray", color: "#000000" },
    { name: "Unity / Unreal Engine", color: "#000000" },
  ],
  testimonialsList: [
    { name: "Arjun K.", role: "Alumni", rating: 5, text: "The most practical 3D animation training for learning modeling and rigging." },
    { name: "Meera R.", role: "Alumni", rating: 5, text: "Great 3D animation online course with hands-on projects and tools." },
    { name: "Kiran P.", role: "Alumni", rating: 5, text: "I learned 3D design from scratch and started working on real projects." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced 3D animators" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real 3D animations" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const motionGraphicsTrainingData = makeTrainingData({
  heroTitle: "Motion Graphics Course in Bengaluru - Create Dynamic Visuals & Effects",
  heroSubtitle: "Master motion design with our expert-led motion graphics training. Learn animated logos, visual effects, and storytelling with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Motion Graphics Career Today",
  heroFormSubtitle: "Fill in your details and connect with our motion design experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Motion Graphics Course - From Basics to Advanced Motion Design",
  aboutBadge: "Specialized Motion Graphics Training",
  about1: "Our motion graphics course helps you learn animated design from scratch with a practical approach.",
  about2: "This motion graphics online course covers animated typography, logo animation, and VFX with real-time projects.",
  aboutHighlights: [
    "Industry-aligned motion graphics curriculum",
    "Hands-on training with live design projects",
    "Animated typography and logo techniques",
    "Visual effects and 2D motion design",
    "1-on-1 mentorship & feedback sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "Motion Graphics",
  frontEnd: ["Introduction to Motion Design", "Design Principles", "Typography Animation", "Color Schemes", "Layout & Storytelling", "Vector Graphics"],
  backEnd: ["Keyframing & Motion", "Visual Effects (VFX)", "Animated Logos", "Transitions & Effects", "Digital Compositing", "Final Video Production"],
  database: ["Adobe After Effects", "Adobe Premiere Pro", "Adobe Illustrator", "Cinema 4D Basics", "Adobe Photoshop", "Real-Time Motion Projects"],
  months: [
    { month: "Week 1-2", title: "Design Fundamentals", topics: ["Principles of Motion Design", "History and Trends", "Basic Tools", "Motion Theory"] },
    { month: "Week 3-4", title: "Motion Basics", topics: ["Keyframing", "Easing and Timing", "Basic Animation", "Tools Introduction"] },
    { month: "Week 5-6", title: "Advanced Motion", topics: ["Animated Typography", "Vector Animation", "Logo Animation", "Transitions"] },
    { month: "Week 7-8", title: "Visual Effects (VFX)", topics: ["Masking and Tracking", "VFX Basics", "Compositing", "Layer Effects"] },
    { month: "Week 9-10", title: "Logo and Branding", topics: ["Branding Animation", "Logo Design to Motion", "Identity Animation", "Creative Planning"] },
    { month: "Week 11-12", title: "Final Projects", topics: ["Portfolio Building", "Real Motion Projects", "Client Presentations", "Final Video Production"] },
  ],
  ctaTitle: "Ready to Become a Motion Designer?",
  ctaSubtitle: "Learn from experts, build real motion graphics, and grow your career with our motion graphics course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with our easy-to-learn motion graphics course for beginners", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Designers", text: "Learn motion graphics from basics to advanced level", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Graphic Designers", text: "Upgrade your skills with motion graphics training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer motion design services and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Video Editors", text: "Enhance your video content with motion graphics", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Design engaging animated visuals for social media", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Adobe After Effects", color: "#9999FF" },
    { name: "Adobe Premiere Pro", color: "#9999FF" },
    { name: "Maxon Cinema 4D", color: "#003366" },
    { name: "Adobe Illustrator", color: "#FF9A00" },
    { name: "Adobe Photoshop", color: "#31A8FF" },
    { name: "Lottie", color: "#000000" },
    { name: "Figma", color: "#F24E1E" },
    { name: "Baval", color: "#000000" },
  ],
  testimonialsList: [
    { name: "Arjun K.", role: "Alumni", rating: 5, text: "The best motion graphics course for learning logo animation and VFX." },
    { name: "Meera R.", role: "Alumni", rating: 5, text: "Practical motion graphics training with hands-on projects and exercises." },
    { name: "Kiran P.", role: "Alumni", rating: 5, text: "I started working on real projects after finishing the motion graphics online course." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced motion designers" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real motion graphics" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const videoEditingTrainingData = makeTrainingData({
  heroTitle: "Video Editing Course in Bengaluru - Master Visual Storytelling & VFX",
  heroSubtitle: "Learn to create professional videos with our expert-led video editing training in Bangalore. Master storytelling, cutting, color grading, and VFX with real-time projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Video Editing Career Today",
  heroFormSubtitle: "Fill in your details and connect with our video experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Video Editing Course - From Basics to Professional Video Editing",
  aboutBadge: "Specialized Video Editing Training",
  about1: "Our video editing course helps you master storytelling and visual content from scratch with a practical approach.",
  about2: "This video editing course near me covers advanced editing, color grading, and VFX with real-time projects.",
  aboutHighlights: [
    "Industry-aligned video editing curriculum",
    "Hands-on training with live video projects",
    "Storytelling and color grading techniques",
    "VFX and motion graphics integration",
    "1-on-1 mentorship & feedback sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "3 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "6+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "3 Months", courseLabel: "Video Editing & VFX",
  frontEnd: ["Introduction to Video Editing", "Storytelling & Pacing", "Timeline & Organization", "Basic Transitions", "Text & Graphics", "Audio Editing Foundations"],
  backEnd: ["Advanced Color Grading", "VFX Compositing", "Multi-cam Editing", "Sound Design & Mixing", "Digital Effects", "Final Video Production"],
  database: ["Adobe Premiere Pro", "Adobe After Effects", "DaVinci Resolve", "Adobe Audition", "Adobe Photoshop", "Real-Time Video Projects"],
  months: [
    { month: "Week 1-2", title: "Introduction to Editing", topics: ["Editing Basics", "Interface and Workflow", "Cut and Transitions", "Storytelling Fundamentals"] },
    { month: "Week 3-4", title: "Advanced Editing Techniques", topics: ["Pacing and Rhythm", "Sound Design Basics", "Text and Titling", "Graphics Integration"] },
    { month: "Week 5-6", title: "Visual Effects (VFX)", topics: ["Basic VFX", "After Effects Integration", "Compositing", "Motion Design"] },
    { month: "Week 7-8", title: "Color Grading and Correction", topics: ["Color Theory", "Grading Tools", "Correction Techniques", "Visual Enhancements"] },
    { month: "Week 9-10", title: "Audio and Final Polish", topics: ["Audio Mixing", "Sound Effects", "Final Cut Production", "Quality Control"] },
    { month: "Week 11-12", title: "Portfolio and Final Works", topics: ["Real Video Projects", "Portfolio Development", "Client Workflow", "Final Presentations"] },
  ],
  ctaTitle: "Ready to Become a Video Editor?",
  ctaSubtitle: "Learn from experts, build real videos, and grow your career with our video editing course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your career with our best video editing course for beginners", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Video Editors", text: "Learn video editing from basics to advanced level", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Graphic Designers", text: "Upgrade your skills with video editing training", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "YouTube Creators", text: "Increase video quality and engagement", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Offer video editing services and grow your income", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Entrepreneurs", text: "Create high-quality video content for your brand", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Adobe Premiere Pro", color: "#9999FF" },
    { name: "Adobe After Effects", color: "#9999FF" },
    { name: "DaVinci Resolve", color: "#000000" },
    { name: "Adobe Audition", color: "#00E5D1" },
    { name: "Adobe Photoshop", color: "#31A8FF" },
    { name: "Final Cut Pro", color: "#4EA9FF" },
    { name: "Filmora", color: "#00CC99" },
    { name: "OBS Studio", color: "#000000" },
  ],
  testimonialsList: [
    { name: "Arjun K.", role: "Alumni", rating: 5, text: "The most practical video editing training for learning storytelling and grading." },
    { name: "Meera R.", role: "Alumni", rating: 5, text: "Great video editing course near me with hands-on projects and tools." },
    { name: "Kiran P.", role: "Alumni", rating: 5, text: "I learned professional editing from scratch and started my YouTube channel." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced video editors" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Build real videos" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});

export const explainerVideoTrainingData = makeTrainingData({
  heroTitle: "Explainer Video Course in Bengaluru - Create Engaging Animated Videos",
  heroSubtitle: "Our expert-led explainer video course teaches storytelling and animation skills. Students learn to create scripts and voiceover work and animation and video editing through practical projects.",
  heroBadge: "🚀 New Batch Starting Soon - Only Limited Seats Available!",
  heroUrgency: "⚡ Limited Seats Available - Enroll Before Batch Fills!",
  heroFormTitle: "Start Your Explainer Video Career Today",
  heroFormSubtitle: "Fill in your details and connect with our animation experts.",
  heroFormBtn: "Apply for Early Seat",
  aboutTitle: "Explainer Video Course - From Basics to Professional Animation",
  aboutBadge: "Specialized Explainer Video Training",
  about1: "Our explainer video course helps you create engaging and high-converting videos with a practical approach.",
  about2: "This best explainer video course covers scripting, animation, voiceover, and editing with real-time projects.",
  aboutHighlights: [
    "Industry-aligned animation curriculum",
    "Hands-on training with live video projects",
    "Scriptwriting and storytelling techniques",
    "Animation and editing tools covered",
    "1-on-1 mentorship & feedback sessions"
  ],
  aboutStats: [
    { label: "Duration", value: "2 Months" },
    { label: "Batch Size", value: "Max 20 Students" },
    { label: "Mode", value: "Online + Offline" },
    { label: "Projects", value: "5+ Live Projects" },
    { label: "Certification", value: "Industry-Recognized" },
    { label: "EMI", value: "0% Interest Available" },
  ],
  duration: "2 Months", courseLabel: "Explainer Videos",
  frontEnd: ["Introduction to Explainer Videos", "Scriptwriting Basics", "Storyboarding", "Visual Planning", "Voiceover Techniques", "Video Structure"],
  backEnd: ["2D Animation Basics", "Motion Graphics", "Transitions & Effects", "Audio Syncing", "Video Editing Techniques", "Exporting & Optimization"],
  database: ["Adobe After Effects", "Adobe Premiere Pro", "Vyond / Animaker", "Canva Video", "Audacity", "Live Video Projects"],
  months: [
    { month: "Month 1", title: "Basics", topics: ["Introduction to Explainer Videos", "Scriptwriting", "Storyboarding", "Basic Animation"] },
    { month: "Month 2", title: "Advanced & Projects", topics: ["Motion Graphics", "Video Editing", "Audio Integration", "Final Project"] },
  ],
  ctaTitle: "Ready to Create Stunning Explainer Videos?",
  ctaSubtitle: "Learn from experts, build real projects, and grow your career with our explainer video course.",
  ctaFooter: "⚡ New Batch Starting Soon - Limited Seats Left!",
  audience: [
    { icon: <SchoolIcon sx={{ fontSize: 28 }} />, label: "Students & Freshers", text: "Start your creative career and join explainer video course easily", accent: "#1d4ed8", bg: "#dbeafe" },
    { icon: <AdsClickIcon sx={{ fontSize: 28 }} />, label: "Aspiring Video Creators", text: "Learn animation and storytelling from basics to advanced", accent: "#6d28d9", bg: "#ede9fe" },
    { icon: <BusinessCenterIcon sx={{ fontSize: 28 }} />, label: "Marketing Professionals", text: "Use videos to boost campaigns and engagement", accent: "#059669", bg: "#ecfdf5" },
    { icon: <StoreIcon sx={{ fontSize: 28 }} />, label: "Freelancers", text: "Create explainer videos and grow your income", accent: "#b45309", bg: "#fffbeb" },
    { icon: <LanguageIcon sx={{ fontSize: 28 }} />, label: "Business Owners", text: "Promote your products using engaging videos", accent: "#0284c7", bg: "#f0f9ff" },
    { icon: <AutoStoriesIcon sx={{ fontSize: 28 }} />, label: "Content Creators", text: "Build your brand with professional video content", accent: "#db2777", bg: "#fdf2f8" },
  ],
  tools: [
    { name: "Adobe After Effects", color: "#9999FF" },
    { name: "Adobe Premiere Pro", color: "#9999FF" },
    { name: "Vyond", color: "#FF6600" },
    { name: "Animaker", color: "#FF9900" },
    { name: "Canva Video", color: "#00C4CC" },
    { name: "Audacity", color: "#0000CC" },
    { name: "Filmora", color: "#00CC99" },
    { name: "DaVinci Resolve", color: "#000000" },
  ],
  testimonialsList: [
    { name: "Arjun K.", role: "Alumni", rating: 5, text: "Great course for learning animation basics." },
    { name: "Meera R.", role: "Alumni", rating: 5, text: "Helped me create professional videos easily." },
    { name: "Kiran P.", role: "Alumni", rating: 5, text: "Simple training with real project experience." },
  ],
  whyChooseUsList: [
    { icon: <SchoolIcon fontSize="large" />, title: "Expert Trainers", desc: "Learn from experienced video creators" },
    { icon: <LaptopMacIcon fontSize="large" />, title: "Hands-On Projects", desc: "Work on real explainer videos" },
    { icon: <WorkIcon fontSize="large" />, title: "Placement Support", desc: "Dedicated career assistance" },
    { icon: <GroupsIcon fontSize="large" />, title: "Small Batch Training", desc: "Personalized attention" },
    { icon: <MenuBookIcon fontSize="large" />, title: "Structured Curriculum", desc: "Step-by-step learning" },
    { icon: <DataObjectIcon fontSize="large" />, title: "Lifetime Access", desc: "Access sessions anytime" },
  ],
});
